import { useState, useEffect } from 'react';
import Drawer, { DrawerHeader } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { FormBody } from 'common/components/drawer';
import { FormFooter } from 'common/components/drawer';
import FormList from 'common/components/form/FormList';
import { Button, Row, Col } from 'reactstrap';

import { useForm, useFormState, useActions } from 'utils/hooks';
import * as companyActions from 'store/companies/actions';
import config from './config';
import Synonym from './Synonym';
import Switch from 'common/components/form/inputs/Switch';

const CompanyDrawer = ({ drawer, active }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [updateCompany] = useActions([companyActions.updateCompany]);
  const { formState, collectValues, loadValues, isDirty, hasErrors } = useForm(config, {});
  const { selectField, subStates, addSubform, removeSubform, fields } = useFormState(formState);

  useEffect(() => {
    if (active) {
      loadForm();
    }
  }, [active, drawer.isOpen]);

  const loadForm = () => {
    const synonyms = active.synonyms.map(synonym => ({ value: synonym }));
    const newValues = {
      ...active,
      synonyms: synonyms.length ? synonyms : [{ value: '' }]
    };
    loadValues(newValues);
    setEnabled(newValues.active);
  };

  const handleSubmitForm = () => {
    const formValues = collectValues();
    if (!formValues) return;

    if (!hasErrors) {
      setIsSubmitting(true);
      const values = {
        ...formValues,
        table: 'organizations',
        id: active.id,
        synonyms: formValues.synonyms.map(synonym => synonym.value).filter(synonym => synonym)
      };

      updateCompany(values);
      setIsSubmitting(false);
      drawer.close();
    }
  };

  const changeEnabled = () => {
    selectField('active')(!enabled);
    setEnabled(!enabled);
  };

  return (
    <Drawer layout="table" {...drawer}>
      <DrawerHeader className="border-bottom pb-4">
        Edit <b>/ {active && active.name}</b>
      </DrawerHeader>
      <FormDrawer>
        <FormBody isDirty={isDirty}>
          <Row noGutters>
            <Col>
              <span className="fs-12 text-uppercase text-primary fw-bold">LOGIN SYNONYMS</span>
              <FormList
                inner
                forms={subStates(`synonyms`)}
                className="w-100p add-button-form-list-right"
                formListclassName="bg-white pt-0 pb-0 px-0 mb-0 outside"
                onAdd={() => addSubform('synonyms', { value: '' })}
                onRemove={index => removeSubform('synonyms', index)}
                addText={'Add more'}
                canRemove={() => (fields ? fields.synonyms.length !== 1 : true)}
              >
                {formState => <Synonym state={formState} />}
              </FormList>
            </Col>
            <Col xs={12} className="mt-2 d-flex align-items-center">
              <span className="fs-12 text-uppercase text-primary fw-bold">ACTIVE STATUS</span>
              <Switch
                className="mb-0 ms-3"
                innerOnLabel="ON"
                innerOffLabel="OFF"
                onChange={changeEnabled}
                value={enabled}
              />
            </Col>
          </Row>
        </FormBody>

        <FormFooter>
          <Button color="cancel" className="px-0 py-1 me-4" onClick={drawer.close}>
            CANCEL
          </Button>
          <Button
            onClick={handleSubmitForm}
            disabled={isSubmitting || !isDirty}
            color="primary"
            className="px-4"
          >
            SAVE
          </Button>
        </FormFooter>
      </FormDrawer>
    </Drawer>
  );
};

export default CompanyDrawer;
